<template>
  <!-- KSK064 — merchant-chosen icon (src/config/kioskIcons.js); sized by the
       parent's font-size, coloured by its color. -->
  <svg v-if="name === 'chef_hat'" class="ksk-icon" viewBox="0 0 24 24" aria-hidden="true">
    <component :is="shape.tag" v-for="(shape, i) in chefHat" :key="i" v-bind="shape.attrs" />
  </svg>
  <span v-else class="material-icons-round ksk-icon" aria-hidden="true">{{ ligature }}</span>
</template>

<script>
import { KIOSK_ICONS, CHEF_HAT_SVG_SHAPES } from "@/config/kioskIcons";

export default {
  name: "KskIcon",
  props: {
    name: { type: String, required: true },
  },
  data() {
    return { chefHat: CHEF_HAT_SVG_SHAPES };
  },
  computed: {
    ligature() {
      return KIOSK_ICONS[this.name] || "";
    },
  },
};
</script>

<style scoped>
.ksk-icon {
  font-size: inherit;
  line-height: 1;
}
svg.ksk-icon {
  width: 1em;
  height: 1em;
  fill: currentColor;
}
</style>
